webpackJsonp([35783957827783],{

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ProjectGridItem = exports.ProjectGrid = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(24);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _styled = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ProjectGrid = function ProjectGrid(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    _Container2.default,
	    otherProps,
	    _react2.default.createElement(
	      _styled.Grid,
	      null,
	      children
	    )
	  );
	};
	
	exports.ProjectGrid = ProjectGrid;
	var ProjectGridItem = exports.ProjectGridItem = function ProjectGridItem(_ref2) {
	  var name = _ref2.name,
	      url = _ref2.url,
	      description = _ref2.description,
	      icon = _ref2.icon;
	  return _react2.default.createElement(
	    _styled.Item,
	    null,
	    _react2.default.createElement(
	      _styled.Anchor,
	      { href: url, disabled: !url },
	      _react2.default.createElement(
	        _styled.Icon,
	        null,
	        icon
	      ),
	      _react2.default.createElement(
	        _styled.Content,
	        null,
	        name && _react2.default.createElement(
	          _styled.Name,
	          null,
	          name
	        ),
	        _react2.default.createElement(
	          _styled.Description,
	          null,
	          description
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Description = exports.Name = exports.Content = exports.Icon = exports.Anchor = exports.Item = exports.Grid = undefined;
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Grid = exports.Grid = _styledComponents2.default.ul.withConfig({
	  displayName: 'styled__Grid'
	})(['display:flex;flex-wrap:wrap;list-style:none;']);
	
	var Item = exports.Item = _styledComponents2.default.li.withConfig({
	  displayName: 'styled__Item'
	})(['margin-bottom:2rem;margin-left:auto;margin-right:auto;width:100%;@media ', '{width:50%;}'], _config.screen.mediumUp);
	
	var Anchor = exports.Anchor = _styledComponents2.default.a.withConfig({
	  displayName: 'styled__Anchor'
	})(['display:flex;color:', ';transition:all 200ms ease;', ' &:hover,&:focus{color:', ';text-decoration:none;@media ', '{', ';}}'], _config.colors.secondary, function (props) {
	  return props.disabled && 'pointer-events: disabled;';
	}, function (props) {
	  return props.disabled ? _config.colors.secondary : _config.colors.primary;
	}, _config.screen.mediumUp, function (props) {
	  return !props.disabled && 'padding-left: 0.5rem';
	});
	
	var Icon = exports.Icon = _styledComponents2.default.div.withConfig({
	  displayName: 'styled__Icon'
	})(['flex-shrink:0;width:100px;height:100px;border-radius:10%;overflow:hidden;']);
	
	var Content = exports.Content = _styledComponents2.default.div.withConfig({
	  displayName: 'styled__Content'
	})(['display:flex;flex-direction:column;justify-content:center;padding-left:2rem;']);
	
	var Name = exports.Name = _styledComponents2.default.p.withConfig({
	  displayName: 'styled__Name'
	})(['padding-bottom:1rem;font-size:1.2rem;']);
	
	var Description = exports.Description = _styledComponents2.default.p.withConfig({
	  displayName: 'styled__Description'
	})(['max-width:320px;']);

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectGrid = __webpack_require__(230);
	
	var _config = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var firstProjectsRow = _config.projects.slice(0, 2);
	var secondProjectsRow = _config.projects.slice(2, 4);
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _ProjectGrid.ProjectGrid,
	        { offCenter: true, bottomSpacing: true },
	        firstProjectsRow.map(function (project) {
	          return _react2.default.createElement(_ProjectGrid.ProjectGridItem, _extends({}, project, { key: project.id }));
	        })
	      ),
	      _react2.default.createElement(
	        _ProjectGrid.ProjectGrid,
	        { offCenter: true },
	        secondProjectsRow.map(function (project) {
	          return _react2.default.createElement(_ProjectGrid.ProjectGridItem, _extends({}, project, { key: project.id }));
	        })
	      )
	    );
	  };
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-fb7f249ac6f0f66676df.js